module.exports = __webpack_public_path__ + "static/media/step1.0d627cba.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Home/photos/step1.mp4
// module id = 240
// module chunks = 8